import { render } from "./Offer.vue?vue&type=template&id=eece452e"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"
script.render = render

export default script